import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DownloadAltLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "m12 16-.354.354.354.353.354-.353zm.5-12a.5.5 0 0 0-1 0zm-6.854 6.354 6 6 .708-.708-6-6zm6.708 6 6-6-.708-.708-6 6zM12.5 16V4h-1v12z" }),
            React.createElement("path", { stroke: "currentColor", d: "M5 21h14" })));
}
const DownloadAltLight = forwardRef(_DownloadAltLight);
export { DownloadAltLight };
